module.exports = new __parcel__URL__("shop_research_button_inactive.1e458587.png").toString();